import { RoiHandlerBase } from './RoiHandlerBase';
import { ClearRectangle } from './shapes/ClearRectangle';

/**
 * Defines a handler that allows users to place a fixed-size box on the screen.
 */
export class RoiHandlerFixedWidth extends RoiHandlerBase {
  init (surface) {
    const self = this;

    // Retrieve the dimensions of the box.
    let width = self.settings.width;
    let height = self.settings.height;

    // Create the box and add it to the surface so it will be rendered in the surface's draw() phase.
    const shape = new ClearRectangle(0, 0, width, height);
    surface.addShape(shape);

    // Define mouse handler actions.
    surface.setMouseEventHandlers({
      // When the user moves the mouse the rectangle should trace the mouse.
      mousemove (mouse, dragOffset, e) {
        // move the rectangle's center to the new mouse position (to get the center we divide w/h by 2).
        shape.x = mouse.x - shape.w / 2;
        shape.y = mouse.y - shape.h / 2;

        // Invalidate the surface, triggering a repaint on the next draw() cycle.
        surface.valid = false;
      },

      // Once the user lets go of the mouse we're done.
      mousedown (mouse, dragOffset, e) {
        surface.clearMouseHandlers();

        self.signalUserActionComplete(shape);

        RoiHandlerBase.normalizeAndOffset(shape, self.settings.viewportInfo);

        self.finish(shape);
      }
    });
  }
}
